import { createFileRoute } from "@tanstack/react-router";

import { useProjectId } from "../../../shell/project";
import { RobotSessionPage } from "../../../workspaces/fleet/pages/RobotSessionPage";

/** One teleoperation session of a deployed robot: its recording plays, then its facts. The
 *  robot's Overview lists its recent sessions and each row opens this page. */
export const Route = createFileRoute("/_console/p/$org/$project/deploy/$robot_/sessions/$session")({
  component: SessionRoute,
});

function SessionRoute() {
  const { robot, session } = Route.useParams();
  return <RobotSessionPage projectId={useProjectId()} stationId={robot} sessionId={session} />;
}
